import {isFunction, keys} from 'lodash';
import {hasError, startLoading, gotItem} from './vendorOrders.slice';
import {itemsCollection} from "src/constant/firestore";
import {selectVendorOrders} from "../../constant/selectors";

export const getItemsById = (collection, callback) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startLoading())

            const {byId} = selectVendorOrders(getState())
            const remnants = collection.filter(id => !keys(byId).includes(id))

            await Promise.all(remnants.map(async id => {
                const snap = await itemsCollection.doc(id).get();
                if (snap.exists) {
                    dispatch(gotItem({id, ...snap.data()}))
                }
            }))

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}